import { ReactNode } from "react";

import { FullScreenPage } from "@accurx/navigation";

export const BatchPageContent = ({ children }: { children: ReactNode }) => {
    return (
        <FullScreenPage.Body>
            <FullScreenPage.Container>{children}</FullScreenPage.Container>
        </FullScreenPage.Body>
    );
};

export const BatchPageFooter = ({ children }: { children: ReactNode }) => {
    return (
        <FullScreenPage.Footer>
            <FullScreenPage.Container>{children}</FullScreenPage.Container>
        </FullScreenPage.Footer>
    );
};
